<template>
  <div class="view-container">
    <div class="view-public-package" v-if="!isShowCountry && !isShowUserLogin">
      <div class="lang-con">
        <div class="package-header" @click="switchCountryPage">
          <span class="f14">{{ country.value }}</span>
          <i class="fas fa-solid fa-exchange f13 ml2"></i>
        </div>
        <van-dropdown-menu v-if="terminalTypeList && terminalTypeList.length" active-color="#4361EE" class="terminal-dropdown-menu">
          <van-dropdown-item v-model="terminalTypeValue" :options="terminalTypeList"  @change="terminalTypeChange"/>
        </van-dropdown-menu>
        <div class="lang-select" @click="langTypeShow = true">
          <span class="lang-val">{{ selectLangType.text }}</span>
          <i class="fas fa-chevron-down"></i>
        </div>
      </div>
      <div class="package-contianer">
        <div class="package-head">
          <van-tabs :class="localPackageList.length === 1 ? 'van-tabs-con' : '' " v-if="localPackageList && localPackageList.length && isShowTagList" :active="activeTab" @change="packageTabsChange" swipe-threshold="3"  swipeable animated color="#4361EE" title-active-color="#4361ee" title-inactive-color="#000" line-width="6%" line-height="0.2em">
            <van-tab v-for="tab in localPackageList" :key="tab.tagKey" :title="tab.tagValueName" :name="tab.tagKey"></van-tab>
          </van-tabs>
        </div>
        <div class="package-content">
          <div class="package-tag-item" v-for="(group,index1) in packageList" :key="group.tagValueName">
            <template v-if="group.packageList && group.packageList.length && isShowTagList">
              <h2 class="package-tag-title">{{group.tagValueName}}</h2>
              <div class="package-list">
                  <div class="package-item" v-for="(item,index2) in group.packageList" :key="item.goodsId">
                  <!-- <img v-if="selectPackage && selectPackage.goodsId === item.goodsId" class="selected-icon" src="@/assets/imgs/packages/select_package.png" alt="" /> -->
                  <h3 class="package-flow-rate" :class="item.isUnLimit ? 'package-flow-unlimit' : ''">{{item.showFlow}}</h3>
                  <div class="package-item-validity">
                      <span v-show="item.isShowPeriod">{{item.showPeriod}}</span>   
                  </div>
                  <div class="package-little-text">{{item.goodsName}}</div>
                  <div class="package-item-bpricebox">
                      <div class="package-price" :ref="`priceRef${index1 + '' + index2}`">
                          <span v-show="$i18n.locale !=='ar-AE' || !isCurrencySymbol(item.currencyType)">{{item.priceCurrencyType}}</span>
                          <span class="package-price-int">{{item.goodsIntPrice}}</span>
                          <span>{{item.pricePunctuation}}</span>
                          <span>{{item.goodsDecimalPrice}}</span>
                          <span v-show="$i18n.locale ==='ar-AE' && isCurrencySymbol(item.currencyType)">{{item.priceCurrencyType}}</span>
                          <span class="package-priceUnit" v-show="item.isShowPriceUnit && item.isShowPeriodBottom">{{item.periodBottom}}
                          </span>
                      </div>
                      <div class="package-first-list-price" v-show="item.isShowPeriodBottom && !item.isShowPriceUnit">
                          <span>{{item.periodBottom}}</span>
                      </div>
                  </div>
                  <div class="package-little-text" v-show="item.autoRenewPrice">
                    {{item.autoRenewPrice }}
                  </div>
                  <div class="package-little-text package-list-price" v-show="item.listPriceShow">
                    {{ item.listPrice }}
                  </div>
                  <!-- <div class="package-list-price" v-show="!item.firstListPrice && item.listPriceShow">
                      <span>{{item.listPrice}}</span>
                  </div> -->
                  </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- <div class="package-content">
        <div class="package-header">
          <span class="f14">{{ country.value }}</span>
          <i class="fas fa-solid fa-sliders f16" @click="switchCountryPage"></i>
        </div>
        <div class="package-list">
          <div class="package-list-left" v-if="tagList && tagList.length" ref="packageListLeft">
            <van-sidebar v-model="packageActiveKey">
              <template v-for="(tag, index) in packageGroupList">
                <van-sidebar-item @click="packageListGroupChange" :title="tag.tagValueName" :key="index" class="package-item-tag" :data-index="index" v-if="tag.packageList && tag.packageList.length" />
              </template>
            </van-sidebar>
          </div>
          <div class="package-list-right" ref="packageListRight" @scroll="packageListRightScroll">
            <div class="package-item-group" v-for="(group, index) in packageGroupList" :key="index" :data-index="index">
              <template v-if="group.packageList && group.packageList.length">
                <h2 class="group-title f14">{{ group.tagValueName }}</h2>
                <div class="package-item" v-for="row in group.packageList" :key="row.goodsCode">
                  <img class="sign-icon" v-show="row.saleIconShow" :src="row.saleImageUrl" :style="row.iconStyle" />
                  <h3 class="package-name van-multi-ellipsis--l3 f14">{{ row.goodsName }}</h3>
                  <div class="package-ext-arrt">
                    <div v-if="row.promotionActivityCode && row.actTags && row.actTags[row.promotionActivityCode]">
                      <span class="ext-attr" style="max-weight: 90%">{{ row.actTags[row.promotionActivityCode] }}</span>
                    </div>
                    <div class="ext-attr-con" v-else-if="row.attrValueList && row.attrValueList.length">
                      <span class="ext-attr" v-for="(attrValue, index) in row.attrValueList" :key="index">{{ attrValue }}</span>
                    </div>
                  </div>

                  <div class="package-price-box">
                    <div class="price">{{ row.goodsPriceText }}</div>
                  </div>
                  <div class="package-price-box" v-show="row.autoRenewPrice">
                    <div class="price">{{ row.autoRenewPrice }}</div>
                  </div>
                  <div class="package-price-box" v-show="row.listPriceShow">
                    <span class="list-price">{{ row.listPrice }}</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <SelectCountry v-if="isShowCountry" :isShowCountry.sync="isShowCountry" @selectCountry="selectCounrty"></SelectCountry>
    <UserLogin v-if="isShowUserLogin" :isShowUserLogin.sync="isShowUserLogin" :selectLangType="selectLangType" @selectLang="langTypeShow = true"></UserLogin>
    <!-- 语言选择弹窗 -->
    <van-popup v-model="langTypeShow" round position="bottom" custom-style="height: 30%">
      <van-picker 
        show-toolbar 
        :columns="columns" 
        @cancel="langTypeShow = false" 
        @confirm="onConfirm" 
        value-key="text" 
        :confirm-button-text="$t('registerlogin.confirm')"
        :cancel-button-text="$t('registerlogin.cancel')"
        item-height="6.5vh" />
    </van-popup>
  </div>
</template>

<script>
import SelectCountry from "./components/SelectCountry.vue";
import unlimited_bg from "../../assets/imgs/unlimited@3x.png";
import normal_bg from "../../assets/imgs/normal@3x.png";
import { keepTwodecimalFixed, isAndroid, throttle } from "../../utils/util";
import cookie from '../../utils/cookie'
import { Sidebar, SidebarItem, Popup, Picker, Tab, Tabs, DropdownMenu, DropdownItem } from "vant";
import { langTypes } from "@/data/langTypeList"
import UserLogin from  './components/UserLogin.vue';
export default {
  data() {
    return {
      isShowCountry: false,
      isShowUserLogin: true,
      country: {},
      tagList: [], // 套餐标签列表
      packageGroupList: [], // 套餐分组列表
      packageActiveKey: 0, // 套餐列表的key
      enterPriseList: [], // 分站信息列表
      langTypeShow:false, //
      columns: langTypes,
      selectLangType: {
        text: "中文简体",
        value: "zh-CN",
      },
      regionList: [],
      localPackageList: [],
      activeTab:'LOCAL',
      isShowTagList:false,
      terminalTypeList: [],
      terminalTypeValue: '',
      allTagList: [],
    };
  },
  components: {
    SelectCountry,
    vanSidebar: Sidebar,
    vanSidebarItem: SidebarItem,
    vanPopup: Popup,
    vanPicker: Picker,
    UserLogin,
    vanTabs: Tabs,
    vanTab: Tab,
    vanDropdownMenu:DropdownMenu,
    vanDropdownItem:DropdownItem,
  },
  created() {
      let browserLang = navigator.language.slice(0,2).toLowerCase()
      let langtype = sessionStorage.getItem('langType');
      let langItem = langTypes.find(item => {
        if(['zh-TW','zh-HK'].includes(navigator.language)){
           return item.value === 'zh-TW';
        } else {
          let type = item.value.slice(0,2).toLowerCase();
          return browserLang === type;
        }
      })

      if(langtype){
        langItem = langTypes.find(item => item.value === langtype);
      }

      if(langItem?.value) {
        lang = langItem?.value;
        this.selectLangType.text = langItem?.text;
        this.selectLangType.value = langItem?.value;
      }

      let lang = 'en-US';
      if(browserLang === 'id' && !langItem?.value) {
        lang = 'in-ID';
        this.selectLangType.text = 'Indonesia';
        this.selectLangType.value = 'in-ID';
      }

      let langType = this.$route.query.langType || this.selectLangType.value || 'zh-CN'
      cookie.setCookie('langType', langType,{expires: 365})
      this.$i18n.locale = langType    
      // 对于阿拉伯语进行镜像反转
      const htmlNode = document.documentElement;            
      if(langType === 'ar-AE') {
          htmlNode.setAttribute('dir', 'rtl')
      } else {
        htmlNode.setAttribute('dir', 'ltr')
      }
  },
  computed: {
      packageList() {
          return this.localPackageList.find(item => item.tagKey === this.activeTab)?.packageGroupList || [];
      },
  },
  mounted() {
    this.setTerminalTypeList();
    this.checkLoginStatus();
  },
  methods: {
    // 检查是否登录或登录已过期
    checkLoginStatus() {      
      let packageUser =JSON.parse(sessionStorage.getItem("package_user") || "{}");
      let isExpire = packageUser.login_time ? Math.abs(Date.now() - packageUser.login_time) > ( 12 * 60 * 60 * 1000) : true; // 12小时过期
      if(!packageUser.login_time || isExpire){
          this.isShowUserLogin = true;
      } else {
        this.isShowUserLogin = false;
        // 神策-设置公共属性
        this.$sensors.registerPage({
            user_account: packageUser.user_account,
        });
        this.httpGetEnterpriseConfigList();
      }
    },
    // 设置设备类型
    setTerminalTypeList() {
        let enterpriseMap = {
          '/pl': 'EA00011095',
          '/ottocast': 'EA00011068'
        }
        let path = this.$route.path;
        let enterprise = this.$route.query.enterprisecode || enterpriseMap[path];
        let terminalTypeData = this.$APP_CONFIG[enterprise + '_TerminalType'];
        if(terminalTypeData){
          for (const key in terminalTypeData) {
            const element = terminalTypeData[key];
            this.terminalTypeList.push({
              text: key,
              value: element,
            })
          }
          this.terminalTypeValue = this.terminalTypeList[0].value;
        }
    },
    // 选择设备类型
    terminalTypeChange(value){
      this.terminalTypeValue = value;
      this.localPackageList = [];
      this.allTagList.forEach((element) => {
        if (element.tagKey === "LOCAL" && element.tagValueList) {
          this.localPackageList.push({
              tagValueName: element.tagName,
              tagKey: element.tagKey,
              packageGroupList: [],
          });

        }
      });
      let mvnoCode = this.selectOrg?.mvnoCode || "";
      let orgCode = this.selectOrg?.orgCode || "";
      let orgId = this.selectOrg?.orgId || "";
            // 获取流量套餐列表
      this.getLocalPackageList(this.country.key, {
          mvnoCode,
          orgCode,
          orgId,
      });
    },
    packageTabsChange(name) {
        this.activeTab = name; // 设置当前激活的标签
        this.handlerPriceUnit();
    },
    // 设置单个tab靠左
    setOneTabLeft() {
        setTimeout(() => {
            const elementA = document.querySelector('.van-tab');
            const elementB = document.querySelector('.van-tab__text');
            const elementC = document.querySelector('.van-tabs__line');
            let left = elementA.offsetLeft + elementB.offsetLeft + (elementB.offsetWidth / 2) - (elementC.offsetWidth / 2);
            elementC.style.transform = `translateX(${left}px)`;
        },0)
    },
    // 金额单位换行处理
    handlerPriceUnit() {
        if(!this.packageList || !this.packageList.length) return;
        this.$nextTick(() => {
            this.packageList.forEach((packageTag,index1) => {
                packageTag.packageList.forEach((item,index2) => {
                    // 将this.$refs[`priceRef${index}`]下所有的子元素宽度加起来
                    if(item.categoryCode !== 'LXCX'){
                        item.isShowPriceUnit = false;
                        return;
                    }
                    if(item.isOver) return; // 已经计算过的就不再计算
                    let totalWidth = 0;
                    let priceRef = this.$refs[`priceRef${index1 + '' + index2}`][0] || this.$refs[`priceRef${index1 + '' + index2}`] || null;

                    if(!priceRef) return;
                    let children = priceRef?.children || [];
                    for(let i = 0; i < children.length; i++) {
                        totalWidth += children[i].offsetWidth;
                    }
    
                    if( totalWidth >= priceRef.offsetWidth - 35 ){
                        item.isShowPriceUnit = false;
                    } else {
                        item.isShowPriceUnit = true;
                    }
                    item.isOver = true;
                })
            })
        })
        
        return '';
    },
    // 语言选择确认
    onConfirm(lang) {
      if (lang?.value) {
        let langType = lang.value
        this.selectLangType.text = lang.text;
        this.selectLangType.value = langType;
        this.$i18n.locale = langType;
        cookie.setCookie('langType', langType,{expires: 365})
          // 对于阿拉伯语进行镜像反转
        const htmlNode = document.documentElement;  
        if(langType === 'ar-AE') {
            htmlNode.setAttribute('dir', 'rtl')
        } else {
          htmlNode.setAttribute('dir', 'ltr')
        }
        document.title = this.$t('common.title');

        sessionStorage.setItem('langType', langType);

        let mvnoCode = this.selectOrg?.mvnoCode || "";
        let orgCode = this.selectOrg?.orgCode || "";
        let orgId = this.selectOrg?.orgId || "";

        this.httpcountryGroup();
        this.isShowTagList = false;
        // 获取套餐标签
        this.getPackageTagList(this.selectOrg?.orgId, () => {
          this.getHotRegion(mvnoCode, () => {
              // 获取流量套餐列表
              this.getLocalPackageList(this.country.key, {
                  mvnoCode,
                  orgCode,
                  orgId,
              });
          })
        });
      }
      this.langTypeShow = false;
    },
    // 切换选择国家
    switchCountryPage() {
      this.isShowCountry = !this.isShowCountry;
      this.packageActiveKey = 0; // 重置套餐列表的key
    },
    // 选择国家
    selectCounrty(country) {
      this.country = country;
      this.selectOrg = this.enterPriseList.find((item) => item.iso2List.includes(country.key));
      let mvnoCode = this.selectOrg?.mvnoCode || "";
      let orgCode = this.selectOrg?.orgCode || "";
      let orgId = this.selectOrg?.orgId || "";
      this.isShowTagList = false;
      this.getPackageTagList(orgId, () => {
        this.getHotRegion(mvnoCode, () => {
            // 获取流量套餐列表
            this.getLocalPackageList(country.key, {
                mvnoCode,
                orgCode,
                orgId,
            });
        })
      });
    },
    // 套餐列表左侧切换
    packageListGroupChange(index) {
      const target = document.querySelector(`.package-item-group[data-index="${index}"]`);
      let top = target.offsetTop;
      this.scrollFlag = true; // 设置滚动标志，避免重复触发
      this.$refs.packageListRight.scrollTo({
        top: top,
        behavior: "smooth",
      });
      setTimeout(() => {
        this.scrollFlag = false; // 重置滚动标志
      }, 800);
    },
    // 监听套餐列表右侧滚动事件
    packageListRightScroll: throttle(function () {
      if (this.scrollFlag || !this.packageGroupList.length) return; // 如果正在滚动，则不处理
      const anchors = document.querySelectorAll(".package-item-group[data-index]");
      let scrollTop = this.$refs.packageListRight.scrollTop;
      if (scrollTop <= 30) {
        this.packageActiveKey = 0; // 回到顶部时设置为第一个标签
        return;
      } else if (scrollTop + this.$refs.packageListRight.clientHeight >= this.$refs.packageListRight.scrollHeight - 30) {
        this.packageActiveKey = anchors.length - 1; // 滚动到底部时设置为最后一个标签
        return;
      }
      // 遍历所有的锚点，根据当前滚动位置设置激活的标签
      anchors.forEach((anchor) => {
        const groupTop = anchor.offsetTop;
        const groupHeight = anchor.offsetHeight;
        if (scrollTop >= groupTop - 20 && scrollTop < groupTop + groupHeight - 50) {
          this.packageActiveKey = anchor.dataset.index;
          const target = document.querySelector(`.package-item-tag[data-index="${anchor.dataset.index}"]`);
          if (!target) return;
          let top = target.offsetTop;
          this.$refs.packageListLeft.scrollTo({
            top: top,
            behavior: "smooth",
          });
        }
      });
    }, 300),
    // 接口获取国家
    httpcountryGroup() {
      this.$http
        .post({
          url: "/bss/app/noauth/QueryCoverCountyInfo",
          data: {
            partnerCode: "MAYA",
            // coverFlag: "SHOW",
          },
          auth:false,
        })
        .then((res) => {
          if (res.data) {
            let country = res.data.find(item => item.iso2 === this.country.key);
            this.country.value = country?.countryName || this.country.value;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast(err);
        });
    },
    // 接口获取分站信息
    httpGetEnterpriseConfigList() {
      let enterpriseMap = {
        '/pl': 'EA00011095',
        '/ottocast': 'EA00011068'
      }
      let path = this.$route.path;
      this.$http
        .post({
          url: "/bss/app/noauth/queryEnterpriseConfigList",
          data: {
            partnerCode: "MAYA",
            enterpriseCode: this.$route.query.enterprisecode || enterpriseMap[path],
          },
          auth: false,
        })
        .then((res) => {
          if (res.data && res.data.length) {
            this.enterPriseList = res.data;
            this.country = {
              key: res.data[0].iso2List[0],
              value: res.data[0].countryNameList[0],
            };
            this.selectOrg = res.data[0];
            // 获取套餐标签
            this.getPackageTagList(res.data[0].orgId, () => {
              this.getHotRegion(res.data[0].mvnoCode, () => {
                  // 获取流量套餐列表
                  this.getLocalPackageList(res.data[0].iso2List[0], {
                    mvnoCode:res.data[0].mvnoCode,
                    orgCode:res.data[0].orgCode,
                    orgId:res.data[0].orgId,
                  });
              })
            });
          }
        })
        .catch((err) => {
          this.$toast(err);
        });
    },
    // 查询套餐标签
    getPackageTagList(orgId, success) {
      this.localPackageList = [];
      this.$http
        .post({
          url: "bss/app/noauth/QueryOfferTag",
          data: {
            ignoreOfferTagFlag: 1,
            offerTagFlag: 0,
            offerTagMethod: 1,
            orgId,
          },
          auth: false,
        })
        .then((res) => {
          if (res.data && res.data.length) {
            res.data.forEach((element) => {
              if (element.tagKey === "LOCAL" && element.tagValueList) {
                //
                this.tagList = element.tagValueList.map((item) => {
                  return {
                    ...item,
                    // 获取element.extendValueMap的key
                    extendValue: Object.keys(item.extendValueMap)[0] || "",
                    key: Object.keys(item.extendValueMap)[0] || "",
                    value: item.tagValueName
                  };
                });

                this.localPackageList.push({
                    tagValueName: element.tagName,
                    tagKey: element.tagKey,
                    packageGroupList: [],
                });

              }

              if(element.tagKey === "ROAMING" ){
                this.roamingObj = element;
              } 
            });
            this.allTagList = res.data;
          }
          success && success();
        })
        .catch((err) => {
          success && success();
          console.log(err);
        });
    },
    // 查询热门大洲套餐
    async getHotRegion(mvnoCode, success) {
        let typeCode ;
        let typeCode_mvnoCode = mvnoCode || this.selectOrg?.mvnoCode || "";

        if(typeCode_mvnoCode){
            typeCode =  `HOTREGION_${typeCode_mvnoCode.toUpperCase()}`;
            this.$http.post({
                url: '/bss/app/noauth/dictionary/QueryDictionaryValueListInfo',
                data: {                      
                    type: typeCode,
                }
            }).then(res => {
                // Africa - UN60 、Oceania - UN29、 Asia - UN50、European - UN52、SouthAmerica - UN57、 NorthAmerica - UN57
                this.regionList = res.data || [];
                success && success();
            }).catch(() => {
              success && success();
            });
        } else {
            success && success();
        }
    },
    // 全球漫游服务
    getRoamingPackageList(orgObj = {}) {
        let tagKeyList = this.tagList.map(item => item.extendValue);
        let channelType = this.$APP_CONFIG.request.channelType;
        let extendAttrs = this.regionList.map(item => item.key);
        this.$http.post({
            url: '/bss/app/noauth/QueryOfferList',
            data: {                        
                channelType,
                queryLimitFlag: true,
                queryPromotionFlag: true,
                sortFlag: 1,
                showFlowFlag:1,
                filterSimFlag: 1,
                perPageCount: 2000,
                mccFlag: "WHITE",
                areaFlag: 'ROAMING', // 全球漫游
                params: {
                  queryVipDayFlag: true
                },
                goodsExtendAttrs:["detailRemark","hideFlowSize",...extendAttrs], // detailRemark 获取扩展属性
                ...orgObj,
            },
            auth: false,
        }).then(res => {
            let terminalTypeValue = this.terminalTypeValue.split(',');
            let tmpList = (res.data.dataList || []).filter(item => {
                // 过滤设备类型
                if(terminalTypeValue && terminalTypeValue.length && item?.attrMap?.buyTerminalType){
                    let isHave = terminalTypeValue.some(type => item?.attrMap?.buyTerminalType?.includes(type));
                    return isHave;
                }
                return true;
            });
            tmpList = tmpList.length > 0 ? this.initLocalPackageData(tmpList) : [];

            // 按套餐标签进行分类
            tmpList = tmpList.map(item => ({...item, attrValueList: [] }));  
            tmpList.forEach(item => {
                if(item.extendValVos && item.extendValVos.length){
                    item.extendValVos.forEach(val => {
                        item.attrValueList = [...item.attrValueList, ...val.attrValueList];
                    });
                    item.attrCodeList = item.extendValVos.map((val) => val.attrCode);
                }

            });

            if(tmpList && tmpList.length) {
              let list = this.handlerTagSort(tmpList || [], this.regionList);
              let pObj = {
                  tagValueName: this.roamingObj.tagName,
                  tagKey: this.roamingObj.tagKey,
                  packageGroupList: list,
              }
  
              this.localPackageList.push(pObj);
            }

            // 将其他标签中套餐倒序排序
            this.localPackageList.forEach(item => {
              item.packageGroupList.forEach(group => {
                  if(group.tagKey === 'OTHER' && group.packageList.length){
                    group.packageList = group.packageList.sort((a,b) => {
                        let aFlow = a.flowByte;
                        let bFlow = b.flowByte;
                        let aPeriod;
                        let bPeriod;
                        if(a.billingInfos && a.billingInfos.length){
                          aFlow = a.billingInfos[0].flow || a.flowByte;
                          let periodUnit = +a.billingInfos[0].periodUnit;
                          switch (periodUnit) {
                            case 0:
                              aPeriod = a.billingInfos[0].period / 24;
                              break;
                            case 1:
                              aPeriod = a.billingInfos[0].period;
                              break;
                            case 2:
                              aPeriod = a.billingInfos[0].period * 30;
                              break;
                            case 3:
                              aPeriod = a.billingInfos[0].period * 12 * 30;
                              break;
                            case 12:
                              aPeriod = a.billingInfos[0].period * 30;
                              break;
                          }
                        }
                        if(b.billingInfos && b.billingInfos.length){
                          bFlow = b.billingInfos[0].flow || b.flowByte;
                          let periodUnit = +b.billingInfos[0].periodUnit;
                          switch (periodUnit) {
                            case 0:
                              bPeriod = b.billingInfos[0].period / 24;
                              break;
                            case 1:
                              bPeriod = b.billingInfos[0].period;
                              break;
                            case 2:
                              bPeriod = b.billingInfos[0].period * 30;
                              break;
                            case 3:
                              bPeriod = b.billingInfos[0].period * 12 * 30;
                              break;
                            case 12:
                              bPeriod = b.billingInfos[0].period * 30;
                              break;
                          }
                        }
                        if(aFlow == bFlow){
                          aPeriod = aPeriod ? aPeriod : (a.periodUnit === "DAY" ? +a.period : +a.period * 30);
                          bPeriod = bPeriod ? bPeriod : (b.periodUnit === "DAY" ? +b.period : +b.period * 30);
                          return bPeriod - aPeriod;
                        }
                        return bFlow - aFlow;
                    })
                  }
              })
            })

            this.localPackageList = this.localPackageList.filter(item => {
              return item.packageGroupList && item.packageGroupList.length;
            });
            this.activeTab = this.localPackageList[0]?.tagKey || 'LOCAL';
            if(this.localPackageList.length === 1){
                this.setOneTabLeft();
            }
            this.isShowTagList = true;
            this.$nextTick(() => {
                this.handlerPriceUnit();
            })
        }).catch(err => {
            this.$toast(err);
            console.log(err);
        });
    },
    // 本地流量
    getLocalPackageList(mcc, orgObj = {}) {
      let channelType = this.$APP_CONFIG.request.channelType;
      let tagKeyList = this.tagList.map(item => item.extendValue);
      let extendAttrs = this.regionList.map(item => item.key);
      this.$http
        .post({
          url: "/bss/app/noauth/QueryOfferList",
          data: {
            queryLimitFlag: true,
            queryPromotionFlag: true,
            queryVipDayFlag: true,
            channelType,
            filterSimFlag: 1,
            ...orgObj,
            mcc,
            mccFlag: "WHITE",
            areaFlag: 'LOCAL', // 保留原来没有extendValueMap的逻辑，查询本地流量套餐
            sortFlag: 1,
            showFlowFlag: 1,
            perPageCount: 2000,
            params: {
              queryVipDayFlag: true,
            },
            goodsExtendAttrs: ["detailRemark", "petService", "baseService", "humanService", "locationService", "recommendZone", "advanceService", "crossRegionZone", ...tagKeyList, ...extendAttrs], // detailRemark 获取扩展属性
          },
          auth: false,
        })
        .then((res) => {
          let terminalTypeValue = this.terminalTypeValue.split(',');
          let tmpList = (res.data.dataList || []).filter(item => {
              // 过滤设备类型
              if(terminalTypeValue && terminalTypeValue.length && item?.attrMap?.buyTerminalType){
                  let isHave = terminalTypeValue.some(type => item?.attrMap?.buyTerminalType?.includes(type));
                  return isHave;
              }
              return true;
          });
          tmpList = tmpList.length > 0 ? this.initLocalPackageData(tmpList) : [];
          // 展示套餐标签
          tmpList = tmpList.map((item) => ({ ...item, attrValueList: [] }));
          tmpList.forEach((item) => {
            if (item.extendValVos && item.extendValVos.length) {
              item.extendValVos.forEach((val) => {
                if (val.attrCode === "detailRemark") {
                  item.attrValueList = [...item.attrValueList, ...val.attrValueList];
                }
              });
              item.attrCodeList = item.extendValVos.map((val) => val.attrCode);
            }
          });

          let localPackageList = tmpList.filter(item => {
              return !item.multiRegionFlag;
          });

          let list = this.handlerTagSort(localPackageList, this.tagList);
          
          this.localPackageList.forEach(item => {
              if(item.tagKey === 'LOCAL') { 
                  item.packageGroupList = list;
              }
          });

          let regionPackageList = tmpList.filter(item => {
              return item.multiRegionFlag;
          });
          

          // 区域流量 - 有区域标签
          this.regionList.forEach(region => {
            let list = regionPackageList.filter(item => {
                return item.extendValVos?.some(val => val.attrCode === region.key);
            });
            if(!list || !list.length) return;
            let pObj = {
                tagValueName: region.value,
                tagKey: region.key,
                packageGroupList: this.handlerTagSort(list || [], this.tagList),
            }

            this.localPackageList.push(pObj);
            
          })

          // 区域流量 - 无区域标签
          let nonTabRegion = regionPackageList.filter(item => {
            let attr = item.extendValVos?.find(val => extendAttrs.includes(val.attrCode)) || {};

            return !attr?.attrCode
          })

          if(nonTabRegion && nonTabRegion.length){
              let pObj = {
                  tagValueName: this.$t('packages.regional_data'),
                  tagKey: 'AREA',
                  packageGroupList: this.handlerTagSort(nonTabRegion || [], this.tagList),
              }
              this.localPackageList.push(pObj);
          }
          
          // 全球漫游服务 - 有就查询
          if(this.roamingObj){
            this.getRoamingPackageList(orgObj);
          } else {
            // 将其他标签中套餐倒序排序
            this.localPackageList.forEach(item => {
              item.packageGroupList.forEach(group => {
                  if(group.tagKey === 'OTHER' && group.packageList.length){
                    group.packageList = group.packageList.sort((a,b) => {
                        let aFlow = a.flowByte;
                        let bFlow = b.flowByte;
                        let aPeriod;
                        let bPeriod;
                        if(a.billingInfos && a.billingInfos.length){
                          aFlow = a.billingInfos[0].flow || a.flowByte;
                          let periodUnit = +a.billingInfos[0].periodUnit;
                          switch (periodUnit) {
                            case 0:
                              aPeriod = a.billingInfos[0].period / 24;
                              break;
                            case 1:
                              aPeriod = a.billingInfos[0].period;
                              break;
                            case 2:
                              aPeriod = a.billingInfos[0].period * 30;
                              break;
                            case 3:
                              aPeriod = a.billingInfos[0].period * 12 * 30;
                              break;
                            case 12:
                              aPeriod = a.billingInfos[0].period * 30;
                              break;
                          }
                        }
                        if(b.billingInfos && b.billingInfos.length){
                          bFlow = b.billingInfos[0].flow || b.flowByte;
                          let periodUnit = +b.billingInfos[0].periodUnit;
                          switch (periodUnit) {
                            case 0:
                              bPeriod = b.billingInfos[0].period / 24;
                              break;
                            case 1:
                              bPeriod = b.billingInfos[0].period;
                              break;
                            case 2:
                              bPeriod = b.billingInfos[0].period * 30;
                              break;
                            case 3:
                              bPeriod = b.billingInfos[0].period * 12 * 30;
                              break;
                            case 12:
                              bPeriod = b.billingInfos[0].period * 30;
                              break;
                          }
                        }
                        if(aFlow == bFlow){
                          aPeriod = aPeriod ? aPeriod : (a.periodUnit === "DAY" ? +a.period : +a.period * 30);
                          bPeriod = bPeriod ? bPeriod : (b.periodUnit === "DAY" ? +b.period : +b.period * 30);
                          return bPeriod - aPeriod;
                        }
                        return bFlow - aFlow;
                    })
                  }
              })
            })
            this.localPackageList = this.localPackageList.filter(item => {
              return item.packageGroupList && item.packageGroupList.length;
            });
            this.activeTab = this.localPackageList[0]?.tagKey || 'LOCAL';
            if(this.localPackageList.length === 1){
                this.setOneTabLeft();
            }
            this.isShowTagList = true;
            this.$nextTick(() => {
                this.handlerPriceUnit();
            })
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast(err);
        });
    },
    // 标签分类
    handlerTagSort(list = [],tagList) {
        // 按标签进行套餐分类
        let groupList = [];
        if (tagList && tagList.length) {
          tagList.forEach((tag) => {
            let packageList = list.filter((item) => {
              return item.attrCodeList && item.attrCodeList.includes(tag.key);
            });
            if(packageList && packageList.length) {
              groupList.push({
                tagValueName: tag.value,
                packageList,
              });
            }
          });
          let otherList = list.filter((item) => {
            return !item.attrCodeList || !tagList.some((tag) => item.attrCodeList.includes(tag.key));
          });

          (otherList && otherList.length)
            ? groupList.push({
                tagValueName: this.$t('viewPL.other'),
                tagKey: 'OTHER',
                packageList: otherList,
              })
            : null;

        } else {
          list && list.length
            ? (groupList = [
                {
                  packageList: list || [],
                },
              ])
            : (groupList = []);
        }

        return groupList
    },
    initLocalPackageData(list) {
      let newList = [];

      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        item.goodsPrice = +item.goodsPrice + "";

        // 页面只显示DISC、PKAG
        if (item.goodsType != "DISC" && item.goodsType != "PKAG") {
          continue;
        }
        // 过滤黑名单
        if (item.mccFlag && item.mccFlag == "BLACK") {
          continue;
        }
        // 过滤掉用户自定义
        if (item.attrMap.effType == "USER_DEFINED") {
          continue;
        }
        // 过滤掉DIY
        if ((item.goodsType == "DISC" && item.categoryCode == "GDIY") || (item.goodsType == "PKAG" && item.attrMap.pkType == "DIY")) {
          continue;
        }
        // 过滤掉CZME
        if (item.categoryCode && item.categoryCode == "CZME") {
          continue;
        }
        // 过滤DSDS
        /*
                    if(item.terminalType == 'DSDS') {
                        continue;
                    }
                    */

        item.item_bg = unlimited_bg;
        if (item.goodsType == "DISC") {
          item.item_bg = unlimited_bg;
        } else if (item.goodsType == "PKAG") {
          item.item_bg = normal_bg;
        }

        // 处理价格
        item.listPriceShow = false;
        item.vipPriceShow = false;
        if (item.payAgreeFlag == "1" && item.deductionInfo != null && item.deductionInfo.autoRenewActCode != null) {
          // vip会员日并且最低价是discountPrice
          if (item.vipAct && item.vipAct === "1" && this.minPriceIsDiscountPrice(item)) {
            this.doPriceStyle(item, item.goodsPrice, "goodsPriceText");
            this.doPriceStyle(item, item.discountPrice, "vipPrice");
            item.vipPriceShow = true;
          } else {
            let autoRenewFirstPrice = item.deductionInfo.autoRenewFirstPrice ? item.deductionInfo.autoRenewFirstPrice : 0.0;
            if (autoRenewFirstPrice > 0 && autoRenewFirstPrice < item.goodsPrice) {
              this.doPriceStyle(item, this.getMinPrice(item), "goodsPriceText");
              this.doPriceStyle(item, item.deductionInfo.autoRenewPrice, "autoRenewPrice");
              item.listPriceShow = true;
              this.doPriceStyle(item, item.goodsPrice, "listPrice");
            } else {
              this.doPriceStyle(item, this.getMinPrice(item), "goodsPriceText");
            }
          }
        } else {
          // vip 会员日
          if (item.vipAct && item.vipAct === "1") {
            this.doPriceStyle(item, item.goodsPrice, "goodsPriceText");
            this.doPriceStyle(item, item.discountPrice, "vipPrice");
            item.vipPriceShow = true;
          } else {
            this.doPriceStyle(item, item.discountPrice !== null ? item.discountPrice : item.goodsPrice, "goodsPriceText");
            if (item.discountPrice != null) {
              this.doPriceStyle(item, item.goodsPrice, "listPrice");
              item.listPriceShow = true;
            }
          }
        }

        // 格式化价格，拆分为整数和小数
        if(item.goodsPriceText) {
            let lowerCurrency = item.currencyType.toLowerCase();
            let codeType = this.$APP_CONFIG.currencyTypeMap[lowerCurrency] ? this.$APP_CONFIG.currencyTypeMap[lowerCurrency] : item.currencyType;
            item.priceCurrencyType = codeType;
            let price = item.goodsPriceText.split(item.currencyType)[1];
            if(!price && this.$APP_CONFIG.currencyTypeMap[item.currencyType.toLowerCase()]){
                price = item.goodsPriceText.split(this.$APP_CONFIG.currencyTypeMap[item.currencyType.toLowerCase()])[1];
            }
            let priceParts = price.split('.');
            // 保存一下数据
            item.goodsPriceNum = price;
            if(priceParts.length >= 2){
                item.goodsIntPrice = priceParts[0].trim();
                item.goodsDecimalPrice = +priceParts[1] === 0 ? '' : this.formatStringNumber(priceParts[1]);
                item.pricePunctuation =  item.goodsDecimalPrice ? '.' : '';
            } else {
                item.goodsIntPrice = price.split(',')[0].trim();
                item.goodsDecimalPrice = +price.split(',')[1]  === 0 ? '' :  this.formatStringNumber(price.split(',')[1]);
                item.pricePunctuation = item.goodsDecimalPrice ? ',' : '';
            }
        }

        //生成角标
        this.genSaleIcon(item);

        // 流量大小
        item.showFlow = this.doFlowByteText(item);
        item.showPeriod = this.getValidityPeriod(item);
        item.isShowPriceUnit = true;

        item.isShowPeriod = true;

        // 高速流量包
        if(item.goodsType === 'DISC' && item.billingInfos) {
            item.isShowPeriod = true;
            item.isShowPeriodBottom = true;
            item.showPeriod = ' ' + this.handlerBillingInfo(item);
            if(item.billingInfos[0]?.period > 1) item.showPeriod = ' ' + item.billingInfos[0]?.period + this.handlerBillingInfo(item);
            item.periodBottom = this.getUnitOfPrice(item.goodsPriceNum, item.period) + '/' + this.getUnitOfTime(item.periodUnit,1);
        }
        
        // 连续畅想套餐，展示底部月单位
        if(item.categoryCode === 'LXCX'){
            item.isShowPeriod = false;
            item.isShowPeriodBottom = true;
            if(item.period) item.periodBottom = '/' + this.getUnitOfTime(item.periodUnit, item.period);
        }
        
        // 获取隐藏流量大小扩展属性值，用于展示无限流量，2 - 无限流量
        if(item.extendValVos && item.extendValVos.length){
            let isUnLimit = item.extendValVos.some(extend => {
                if(extend.attrCode === 'hideFlowSize' && extend.attrValueList.includes('2')) {
                    return true;
                }
            })
            if(isUnLimit) {
                item.showFlow = this.$t('packages.unLimitData');
                item.isUnLimit = true;
            }
        }

        // multi region packages
        if (item.iso2List && (item.iso2List.length > 1 || item.iso2List[0] == "ALL")) {
          item.multiRegionFlag = true;
        } else if (item.goodsType == "DISC") {
          if (["BYTC", "SWBY", "BTTC", "LXCX"].includes(item.categoryCode)) {
            item.unlimitedFlag = true;
            this.doUnlimitedPackages(item);
          }
        } else if (item.goodsType == "PKAG") {
          if (item.attrMap.pkType != "DIY") {
            item.normalFlag = true;
            this.doNormalPackages(item);
          }
        }

        newList.push(item);
      }

      return newList;
    },
    // 处理年套餐每月金额问题
    getUnitOfPrice(price, num){
        if(!price) return '';
        let priceNum = price.replace(/,/g, ''); // 去掉价格中的逗号

        const result = priceNum / +num;
        const rounded = Math.round(result * 10) / 10; // 四舍五入到一位小数
        
        // 检查是否是整数（考虑浮点数精度）
        if (Math.abs(rounded - Math.round(rounded)) < 0.0001) {
            return Math.round(rounded).toString();
        }
        return rounded.toString();
    },
    // 处理高速流量单位
    handlerBillingInfo(item) {
        let text = '';
        if(item.billingInfos && item.billingInfos.length) {
            let billingInfo = item.billingInfos[0];
            if(billingInfo.periodUnit == 0) {
                if(billingInfo.period > 1){
                    text = this.$t('packages.periodUnits.hour');
                } else {
                    text = this.$t('packages.periodUnit.hour');
                }
            } else if(billingInfo.periodUnit == 1) {
                if(billingInfo.period > 1){
                    text = this.$t('packages.periodUnits.day');
                } else {
                    text = this.$t('packages.periodUnit.day');
                }
            } else if(billingInfo.periodUnit == 2 || billingInfo.periodUnit == 12) {
                if(billingInfo.period > 1){
                    text = this.$t('packages.periodUnits.month');
                } else {
                    text = this.$t('packages.periodUnitMonthly');
                }
            } else if(billingInfo.periodUnit == 3) {
                if(billingInfo.period > 1){
                    text = this.$t('packages.periodUnits.year');
                } else {
                    text = this.$t('packages.periodUnit.year');
                }
            }
        }
        return text;
    },
    // 处理小数位问题
    formatStringNumber(str) {
        // 如果字符串以'0'开头，直接返回原字符串
        if (str.startsWith('0')) {
            return str;
        }
        
        // 将字符串转换为数字，然后去除末尾的零
        let num = parseInt(str, 10);
        
        // 不断除以10直到不能整除
        while (num > 0 && num % 10 === 0) {
            num = Math.floor(num / 10);
        }
        
        return num.toString();
    },
    // 处理流量大小显示
    doFlowByteText(item) {
        let flowText = '0MB',
            flowValue = item.billingInfos && item.billingInfos.length ? item.billingInfos[0].flow : (item.flowByte ? item.flowByte : 0);                    

        if(flowValue >= 1000) {
            let flow = flowValue/1024;
            // 判断是不是整数
            if(Math.floor(flow) === flow) {
                flowText = `${flow}GB`;
            } else {
                let langType = cookie.getCookie('langType')
                // 部分欧洲国家小数点采取 ， 形式
                let country = ['es-ES','pt-PT','de-DE','fr-FR']; 
                let showFlow = keepTwodecimalFixed(flow)
                if(country.includes(langType)){
                    showFlow = showFlow.replace('.',',')
                }
                flowText = `${showFlow}GB`;
            }
        } else {
            flowText = `${flowValue}MB`;
        }

        return flowText;        
    },
    //连续包月增加--20241205--start
    getValidityPeriod (a) {
        // 有效期
        let periodTxt = '';

        if (a.attrMap.expType && (a.attrMap.expType == 'CURRENT_MONTH' || a.attrMap.expType == 'CURRENT_DAY')) {
            periodTxt = this.getTypeOfFailures(a);      // 失效类型
        } else {
            if (a.period == null || a.period == '') {
                periodTxt = '';
            } else {
                let actionType = this.getEffectiveType (a);     // 生效类型
                periodTxt = a.period +' '+ this.getUnitOfTime (a.periodUnit, a.period) + ' ' + actionType;
            }
        }
        return periodTxt;
    },
    getUnitOfTime (a, b) {
        let unit = a;

        if (unit == 'DAY' || unit == null || unit == '') {
            if (parseInt(b) < 2 || b == null || b =='') {
                unit = this.$t('packages.periodUnit.day');
            } else {
                unit = this.$t('packages.periodUnits.day');
            }
        } else if (unit == 'MONTH') {
            if (parseInt(b) < 2 || b == null || b =='') {
                unit = this.$t('packages.periodUnit.month');
            } else {
                unit = this.$t('packages.periodUnits.month');
            }
        }
        return unit;
    },
    getTypeOfFailures (a) {
        // 失效类型
        let actionType = '';

        if (a != null && a != '' && a.attrMap.expType) {
            if (a.attrMap.expType == 'CURRENT_MONTH') {
                actionType = this.$t('packages.month_invalid');
            } else if (a.attrMap.expType == 'CURRENT_DAY') {
                actionType = this.$t('packages.day_invalid');
            } else if (a.attrMap.expType == 'DEFAULT') {
                actionType = '';
            } else {
                actionType = '';
            }
        }
        return  actionType;
    },
    getEffectiveType (a) {
        // 生效类型
        let actionType = '';

        if (a != null && a != '' && a.attrMap.effType) {
            if (a.attrMap.effType == 'IMMEDIATELY') {
                a.period == null || a.period == '' ? actionType = this.$t('packages.immediate_valid') : actionType = ''

            } else if (a.attrMap.effType == 'MORROW') {
                a.period == null || a.period == '' ? actionType = this.$t('packages.tomorrow_day_valid') : actionType = '';

            } else if (a.attrMap.effType == 'USER_DEFINED') {
                actionType = '';

            } else if (a.attrMap.effType == 'NEXT_MONTH') {
                a.period == null || a.period == '' ? actionType = this.$t('packages.tomorrow_month_valid') : actionType = '';

            } else {
                actionType = '';
            }
        }
        return actionType;
    },
    minPriceIsDiscountPrice(item) {
      let autoRenewFirstPrice = item.deductionInfo.autoRenewFirstPrice ? item.deductionInfo.autoRenewFirstPrice : 0.0;
      let autoRenewPrice = item.deductionInfo.autoRenewPrice ? item.deductionInfo.autoRenewPrice : 0.0;
      let discountPrice = item.discountPrice ? item.discountPrice : 0.0;
      if (autoRenewPrice > discountPrice && autoRenewFirstPrice > discountPrice) {
        return true;
      }
      return false;
    },
    doPriceStyle(item, price, key) {
      //price = keepTwodecimalFull(price/100);
      //item[key] = `${item.currencyType} ${price}`;
      item[key] = this.globalPriceFormat(item.currencyType, price);
    },
    genSaleIcon(item) {
      /*
       * sale icon
       * */
      item.saleTextShow = false;
      item.saleIconShow = false;
      let _w = "auto";
      if (isAndroid()) {
        /*
                    if(Math.floor(window.devicePixelRatio) == 1) {
                        _w = `${100/3}%`
                    } else if(Math.floor(window.devicePixelRatio) == 2 || Math.floor(window.devicePixelRatio) == 3) {
                        _w = `${(100*2)/3}%`;
                    }
                    */
      } else {
        if (Math.floor(window.devicePixelRatio) == 1) {
          _w = `${100 / 3}%`;
        } else if (Math.floor(window.devicePixelRatio) == 2) {
          _w = `${(100 * 2) / 3}%`;
        }
      }
      item.saleIconStyle = {
        width: _w,
      };
      let saleImageUrl = "";
      // 获取图标
      if (item.cornerMark != null && Object.values(item.cornerMark).length > 0 && Object.values(item.cornerMark).some((val) => val != "")) {
        if (item.payAgreeFlag == "1" && item.deductionInfo != null && item.deductionInfo.autoRenewActCode != null) {
          saleImageUrl = item.cornerMark[item.deductionInfo.autoRenewActCode];
        } else {
          saleImageUrl = item.cornerMark[item.promotionActivityCode];
        }
      } else if (item.iconInfos && item.iconInfos.length > 0) {
        saleImageUrl = item.iconInfos[0].attrValue;
      }
      // 判断图标是否为空
      if (saleImageUrl) {
        item.saleImageUrl = saleImageUrl;
        item.saleIconShow = true;
      }
      let img = new Image(),
        iconStyle = {};
      img.addEventListener(
        "load",
        () => {
          if (img.width >= this.boxItemWidth) {
            iconStyle = { width: "100%" };
          } else {
            iconStyle = { width: "auto" };
          }
          this.$set(item, "iconStyle", iconStyle);
        },
        false
      );

      if (item.saleImageUrl) {
        img.src = item.saleImageUrl;
      }
    },
    getMinPrice(item) {
        let prices = [];

        if(item.deductionInfo.autoRenewFirstPrice) {
            prices.push(item.deductionInfo.autoRenewFirstPrice);
        }
        if(item.deductionInfo.autoRenewPrice) {
            prices.push(item.deductionInfo.autoRenewPrice);
        }
        if(item.discountPrice) {
            prices.push(item.discountPrice);
        }
        if(item.goodsPrice) {
            prices.push(item.goodsPrice);
        }

        return Math.min(...prices);
    },
    doNormalPackages(item) {
        this.genName(item);
        this.doNormalPackagesCycle(item);
    },
    //处理普通包有效期
    doNormalPackagesCycle(item) {
      let expireToday = item.goodsType != "DISC" && item.attrMap.expType == "CURRENT_DAY",
        expireThisMonth = item.goodsType != "DISC" && item.attrMap.expType == "CURRENT_MONTH",
        effectiveImmediately = item.goodsType == "DISC" && item.attrMap.effType == "IMMEDIATELY",
        effectiveMarrow = item.goodsType == "DISC" && item.attrMap.effType == "MARROW",
        effectiveNextMonth = item.goodsType == "DISC" && item.attrMap.effType == "NEXT_MONTH";

      if (expireToday || expireThisMonth) {
        item.period = expireToday ? `${this.$t("packages.day_invalid")}` : `${this.$t("packages.month_invalid")}`;
      } else {
        if (item.period) {
          let singleUnit = this.$t(`packages.periodUnit.${item.periodUnit.toLowerCase()}`),
            multipleUnit = this.$t(`packages.periodUnits.${item.periodUnit.toLowerCase()}`);
          item.period = item.period > 1 ? `${item.period} ${multipleUnit}` : `${item.period} ${singleUnit}`;
          if (effectiveImmediately) {
            item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t("packages.immediate_valid")})` : `${item.period} ${singleUnit}(${this.$t("packages.immediate_valid")})`;
          } else if (effectiveMarrow) {
            item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t("packages.tomorrow_day_valid")})` : `${item.period} ${singleUnit}(${this.$t("packages.tomorrow_day_valid")})`;
          } else if (effectiveNextMonth) {
            item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t("packages.tomorrow_month_valid")})` : `${item.period} ${singleUnit}(${this.$t("packages.tomorrow_month_valid")})`;
          }
        }
      }
    },
    doUnlimitedPackages(item) {
      this.genName(item);
      // 0为按小时取，1为按天取，2为按月取，3为按年取，12为动态月也是按月取同2
      item.high_speed_text = this.$t("packages.high_speed_text");
      let billInfo = item.billingInfos;
      if (billInfo && billInfo.length > 0) {
        if (billInfo[0].periodUnit === 0) {
          if (item.period == billInfo[0].period && item.periodUnit == "HOUR") {
            item.high_speed_text = this.$t("packages.high_speed_text");
          } else {
            if (billInfo[0].period > 1) {
              item.high_speed_text = item.high_speed_text + "/" + billInfo[0].period + this.$t("packages.periodUnitsSimp.hour");
            } else {
              item.high_speed_text = item.high_speed_text + "/" + this.$t("packages.periodUnitSimp.hour");
            }
          }
        } else if (billInfo[0].periodUnit === 1) {
          if (item.period == billInfo[0].period && item.periodUnit == "DAY") {
            item.high_speed_text = this.$t("packages.high_speed_text");
          } else {
            if (billInfo[0].period > 1) {
              item.high_speed_text = item.high_speed_text + "/" + billInfo[0].period + this.$t("packages.periodUnitSimp.day");
            } else {
              item.high_speed_text = item.high_speed_text + "/" + this.$t("packages.periodUnitSimp.day");
            }
          }
        } else if (billInfo[0].periodUnit === 2 || billInfo[0].periodUnit === 12) {
          if (item.period == billInfo[0].period && item.periodUnit == "MONTH") {
            item.high_speed_text = this.$t("packages.high_speed_text");
          } else {
            if (billInfo[0].period > 1) {
              item.high_speed_text = item.high_speed_text + "/" + billInfo[0].period + this.$t("packages.periodUnitsSimp.month");
            } else {
              item.high_speed_text = item.high_speed_text + "/" + this.$t("packages.periodUnitSimp.month");
            }
          }
        } else if (billInfo[0].periodUnit === 3) {
          if (item.period == billInfo[0].period && item.periodUnit == "YEAR") {
            item.high_speed_text = this.$t("packages.high_speed_text");
          } else {
            if (billInfo[0].period > 1) {
              item.high_speed_text = item.high_speed_text + "/" + billInfo[0].period + this.$t("packages.periodUnitsSimp.year");
            } else {
              item.high_speed_text = item.high_speed_text + "/" + this.$t("packages.periodUnitSimp.year");
            }
          }
        }
      }

      if (item.categoryCode == "BTTC" || (item.categoryCode == "LXCX" && item.periodUnit == "DAY")) {
        item.goodsNameStr = this.$t("packages.unlimited_good_name.day");
      } else if (item.categoryCode == "BYTC" || item.categoryCode == "SWBY" || (item.categoryCode == "LXCX" && item.periodUnit == "MONTH")) {
        if (item.period && item.period == 12) {
          item.goodsNameStr = this.$t("packages.unlimited_good_name.year");
        } else {
          if (item.attrmap && item.attrmap.period && item.attrmap.period == 12) {
            item.goodsNameStr = this.$t("packages.unlimited_good_name.year");
          } else {
            item.goodsNameStr = this.$t("packages.unlimited_good_name.month");
          }
        }
      }
    },
    genName(item) {
      let flow = item.billingInfos && item.billingInfos.length > 0 ? item.billingInfos[0].flow : item.flowByte;
      if (flow > 0) {
        if (flow > 1000) {
          flow = flow / 1024;
          // 判断是不是整数
          if (Math.floor(flow) === flow) {
            item.goodsName_H5_tag = `${flow}GB`;
          } else {
            item.goodsName_H5_tag = `${keepTwodecimalFixed(flow)}GB`;
          }
        } else {
          item.goodsName_H5_tag = `${flow}MB`;
        }
      } else {
        item.goodsName_H5_tag = `0MB`;
      }
    },
    // 判断是否使用了货币符号
    isCurrencySymbol(price='') {
        let typeList = [];
        if(this.$APP_CONFIG.currencyTypeMap) {
            typeList = Object.keys(this.$APP_CONFIG.currencyTypeMap);
        }
        return typeList.some(item => {
            return price?.toLowerCase()?.includes(item) && this.$APP_CONFIG.currencyTypeMap[item];
        })
    },
  },
};
</script>

<style lang="less" scoped>
.view-public-package {
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
  // padding: 16px;
  .lang-con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    padding: 12px;
    flex-wrap: wrap;
  }
  .lang-select {
    min-width: 104px;
    padding: 0 13px;
    // line-height: 32px;
    min-height: 32px;
    border-radius: 16px;
    font-size: 14px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: space-between;
    align-items: center;
    // background-color: color-mix(in oklab, #fff 20%, transparent);
    background-color: #fff;
    // margin-bottom: 10px;
    .lang-val {
        flex: 1;
        margin-right: 5px;
    }
    .down {
        width: 10px;
        height: 8px;
    }
    margin: 3px 0;
  }
  ::v-deep {
    .terminal-dropdown-menu {
      margin: 3px 0;
      border: 1px solid rgba(0, 0, 0, 0.3) !important;
      padding: 0 10px;
      border-radius: 16px;
      .van-dropdown-menu__bar {
        height: 32px !important;
        box-shadow: unset;
        background-color: transparent;
      }
    }
  }
  .package-content {
    // background-color: #fff;
    border-radius: 8px;
    width: 100%;
    height: calc(100vh - 65px);
    overflow-y: auto;
    .package-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 16px;
      border-bottom: 1px solid #e5e6eb;
      margin: 3px 0;
    }
    .package-list {
      display: flex;
      height: calc(100% - 40px);
      .package-list-left {
        border-right: 1px solid #e5e6eb;
        width: 101px;
        height: 100%;
        background-color: #fafafa;
        overflow-y: auto;
        position: relative;
        ::v-deep {
          .van-sidebar {
            width: 100px;
          }
          .van-sidebar-item {
            background-color: #fafafa;
            padding: 12px 10px;
            text-align: center;
          }
          .van-sidebar-item--select {
            &::before {
              display: none;
            }
            background-color: rgba(22, 93, 255, 0.1);
            color: #165dff;
          }
        }
      }
      .package-list-right {
        flex: 1;
        padding-bottom: 12px;
        height: 100%;
        overflow-y: auto;
        position: relative;
        -ms-overflow-style: none; /* IE/Edge */
        scrollbar-width: none; /* Firefox */
        &::-webkit-scrollbar {
          display: none; /* Chrome/Safari/Webkit */
        }
        -webkit-overflow-scrolling: touch;
        .package-item-group {
          margin-bottom: 4px;
          .group-title {
            padding-top: 12px;
            padding-left: 12px;
            padding-bottom: 6px;
            position: sticky;
            top: 0;
            background-color: #fff;
            z-index: 100;
            width: 99%;
          }
          .package-item {
            border-radius: 8px;
            border: 1px solid #e5e6eb;
            margin-top: 15px;
            margin-left: 12px;
            margin-right: 12px;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
            padding: 10px;
            position: relative;
            &:first-of-type {
              margin-top: 6px;
            }
            .package-name {
              font-weight: normal;
              font-family: SourceHanSansCN-Normal;
            }
            .sign-icon {
              object-fit: cover;
              position: absolute;
              top: -5px;
              right: 0;
              max-width: 100%;
              max-height: 16%;
            }
            .package-ext-arrt {
              min-height: 30px;
            }
            .ext-attr-con {
              text-overflow: clip;
              display: block;
              line-height: 0.333333rem;
              // max-height: 1.118111rem;
              overflow: hidden;
            }
            .ext-attr {
              background-color: #e9a944;
              border-radius: 3px;
              color: #fff;
              font-size: 10px;
              padding: 2px 4px;
              line-height: 0.333333rem;
              display: inline-block;
              margin-top: 0.055556rem;
              margin-right: 3px;
              max-width: 80%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .package-price-box {
              line-height: 18px;
              display: flex;
              .price {
                // font-family: Roboto-Medium;
                font-size: 12px;
                color: #165dff;
                // font-weight: 600;
                letter-spacing: 0;
              }
              .list-price {
                position: relative;
                // left: 3px;
                // top: 1px;
                font-size: 12px;
                color: #999999;
                text-decoration: line-through;
              }
            }
            .package-buy-btn {
              margin-top: 4px;
              border-radius: 5px;
              background-color: #165dff;
              color: #fff;
              width: 100%;
              padding: 5px;
              font-size: 12px;
            }
          }
        }
      }
      .package-list-right-no-scroll {
        overflow: hidden;
      }
    }
  }
}

html[dir='rtl'] .view-public-package {
    .lang-con {
        .lang-select {
            .lang-val {
                margin-right: unset;
                margin-left: 5px;
            }
        }
    }
    ::v-deep {
      .terminal-dropdown-menu {
        .van-dropdown-menu__bar {
          .van-dropdown-menu__title {
            &::after {
              right: unset;
              left: -4px;
            }
          }
        }
        .van-dropdown-item {
          .van-cell__title {
            text-align: right;
          }
          .van-cell__value {
            .van-icon {
              text-align: left;
            }
          }
        }
      }
    }
    .package-content {
      .package-list {
        .package-list-right {
          .package-item-group {
            .group-title {
                padding-left: unset;
                padding-right: 12px;
            }
            // .package-price-box {
            //     .list-price {
            //         // left: -2px;
            //     }
            // }
          }
        }
      }
    }
}

.ml2 {
    margin-left: 2px;
}
.package-contianer {
  height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .package-head {
    width: 100%;
    height: 50px;
    background-color: #fff;
    ::v-deep {
      .van-tabs-con {
          .van-tabs__nav {
              justify-content: start;
              padding-left: 10px;
              .van-tab {
                  justify-content: start;
              }
              .van-tabs__line {
                  // transform: translateX(10px) !important;
              }
          }
      }
    }
  }
  .package-content {
    height: 100%;
    overflow-y: auto;
    padding: 0 12px 12px;
    .package-tag-item {
      margin-top: 14px;
      .package-tag-title {
        font-size: 14px;
      }
      .package-list {
        width: 100%;
        margin-top: 6px;
        // display: flex;
        // gap: 10px;
        // flex-wrap: wrap;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px 12px;
        .package-item {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 110px;
          background-color: #fff;
          border-radius: 12px;
          flex-shrink: 0;
          width: 100%;
          text-align: center;
          padding: 20px 0 10px;
          border: 2px solid transparent;
          .selected-icon {
            position: absolute;
            right: -1px;
            top: -1px;
            width: 18px;
            height: 18px;
          }
          .package-flow-rate {
            font-size: 16px;
            word-break: break-all;
            color: #666;
          }
          .package-flow-unlimit {
              font-size: 15px;
              letter-spacing: -1px;
          }
          .package-item-validity {
            margin-top: 2px;
            font-size: 12px;
            font-variation-settings: "opsz" auto;
            font-feature-settings: "kern" on;
            color: rgba(0, 0, 0, 0.5);
            min-height: 32px;
            line-height: 20px;
            word-break: break-all;
          }
          // .package-item-bpricebox {
          //     position: relative;
          //     width: 100%;
          //     bottom: 20px;
          // }
          .package-price {
          //   margin-top: 12px;
            font-family: Source Han Sans;
            font-variation-settings: "opsz" auto;
            font-feature-settings: "kern" on;
            color: #ff4e4e;
            font-size: 10px;
            word-break: break-all;
            padding-left: 1px;
            padding-right: 1px;
            .package-price-int {
              font-size: 16px;
              font-weight: 700;
              margin-left: 2px;
            }
            .package-priceUnit {
              color: rgba(0, 0, 0, 0.5);
            }
          }
          .package-list-price {
            margin-top: 4px;
            font-size: 10px;
            text-decoration: line-through;
            font-variation-settings: "opsz" auto;
            font-feature-settings: "kern" on;
            color: rgba(0, 0, 0, 0.5);
          }
          .package-little-text {
            margin-top: 4px;
            font-size: 10px;
            font-variation-settings: "opsz" auto;
            font-feature-settings: "kern" on;
            color: rgba(0, 0, 0, 0.5);
            word-break: break-all;
          }
          .package-first-list-price {
            margin-top: 4px;
            font-size: 10px;
            padding-left: 5px;
            padding-right: 5px;
            font-variation-settings: "opsz" auto;
            font-feature-settings: "kern" on;
            color: rgba(0, 0, 0, 0.5);
            word-break: break-all;
          }
        }
        .package-item.active {
          border: 2px solid #4361ee;
        }
      }
    }
  }
  .package-footer {
    width: 100%;
    background-color: #fff;
    padding: 12px;
    .gobuy-btn {
      background-color: #4361ee;
      border-radius: 8px;
      width: 100%;
      height: 40px;
    }
  }
}
</style>